import { css } from '@emotion/react'

import { InputStyleProps } from '@surglogs-app/ui'
import { PropsWithTheme } from '@surglogs-app/ui.theme'

export const getLeftPadding = ({
  theme,
  inputSize,
  withIcon,
}: PropsWithTheme<InputStyleProps>) => {
  if (withIcon) {
    return css`
      padding-left: calc(
        ${theme.ui.spacings[inputSize === 'mini' ? 'sm' : 'md']} +
          ${theme.ui.spacings[inputSize === 'mini' ? 'md' : 'lg']} +
          ${theme.ui.spacings[inputSize === 'mini' ? 'xs' : 'sm']}
      );
    `
  }

  return css`
    padding-left: ${theme.ui.spacings[inputSize === 'mini' ? 'abs.12' : 'md']};
  `
}

export const getRightPadding = ({
  theme,
  inputSize,
  adornmentWidth,
}: PropsWithTheme<InputStyleProps>) => {
  if (adornmentWidth) {
    return css`
      padding-right: calc(
        ${theme.ui.spacings[inputSize === 'mini' ? 'sm' : 'md']} +
          ${theme.ui.spacings.xs} + ${adornmentWidth}px
      );
    `
  }

  return css`
    padding-right: ${theme.ui.spacings[inputSize === 'mini' ? 'abs.12' : 'md']};
  `
}

export const getSizeStyles = ({
  theme,
  inputSize,
}: PropsWithTheme<InputStyleProps>) => {
  if (inputSize === 'mini') {
    return css`
      font-size: ${theme.ui.typography.fontSizes.xxs};
      line-height: ${theme.ui.typography.lineHeights.xxs};
      border-radius: ${theme.ui.spacings.sm};
      height: ${theme.ui.spacings.xl};
    `
  }

  return css`
    font-size: ${theme.ui.typography.fontSizes.sm};
    line-height: ${theme.ui.typography.lineHeights.sm};
    border-radius: ${theme.ui.spacings.sm};
    height: ${theme.ui.spacings.xxl};
  `
}

export const getBorderColor = ({
  warning,
  disabled,
  invalid,
}: InputStyleProps) => {
  if (disabled) {
    return 'navy.10'
  }

  if (warning) {
    return 'orange.100'
  }

  if (invalid) {
    return 'red.100'
  }

  return 'navy.25'
}

export const getOutlineColor = ({
  warning,
  disabled,
  invalid,
}: InputStyleProps) => {
  if (disabled) {
    return 'navy.10'
  }

  if (warning) {
    return 'orange.100'
  }

  if (invalid) {
    return 'red.100'
  }

  return 'blue.100'
}
